<template>
  <select class="c-select" style="max-width: 300px;" @change="handleChange">
    <option value=""> -- {{ product.title }} -- </option>
    <option v-for="child in children" :key="child.value.id" :value="child.value.id" :selected="isSelected(child.value.id)">
      {{ child.value.title }}
    </option>
  </select>
  <span class="has-warning" v-if="isRequired && !isOrdered">(Dit is een verplicht artikel. Gelieve hier nog een keuze te maken.)</span>
</template>

<script>
import productSetup from "./product-control-setup";

export default {
  ...productSetup,
};
</script>
